//import { useState, useEffect } from 'react';
//import { useAuth } from '../../../context/AuthContext';
//import { useNavigate } from 'react-router-dom';

//const monthNames = [
//    'January', 'February', 'March', 'April', 'May', 'June',
//    'July', 'August', 'September', 'October', 'November', 'December'
//];

//const OpsSustainabilityData = ({ period }) => {
//    const [sipaData, setSipaData] = useState([0, 0, 0]);
//    const [opsData, setOpsData] = useState();
//    const [isRmsAuthenticated, setIsRmsAuthenticated] = useState(false);
//    const [loading, setLoading] = useState(true);
//    const [sessionExpired, setSessionExpired] = useState(false); // Added state
//    const { apiFetch, logout } = useAuth(); // Ensure logout is available
//    const navigate = useNavigate(); // Ensure navigate is available

//    function getMonthYear(period) {
//        if (!period) return { monthName: '', year: '', prevYear: '' };
//        const periodStr = period.toString().padStart(6, '0');
//        if (periodStr.length !== 6) return { monthName: '', year: '', prevYear: '' };
//        const year = periodStr.substring(0, 4);
//        const prevYear = (parseInt(year, 10) - 1).toString();
//        const month = periodStr.substring(4, 6);
//        const monthNames = [
//            '', 'January', 'February', 'March', 'April', 'May', 'June',
//            'July', 'August', 'September', 'October', 'November', 'December'
//        ];
//        const monthIndex = parseInt(month, 10);
//        return {
//            monthName: monthNames[monthIndex],
//            year,
//            prevYear
//        };
//    }

//    const { monthName, year, prevYear } = getMonthYear(period);

//    const AutenticateRMS = async () => {
//        try {
//            const response = await apiFetch('/api/Rms/authenticate');
//            const data = await response.json();
//            if (data.success) {
//                setIsRmsAuthenticated(true);
//            } else {
//                setIsRmsAuthenticated(false);
//            }
//        } catch (e) {
//            Sentry.captureException(e);
//            console.error("Error fetching sustainability data:", e);
//        }
//    };

//    //const fetchMetersData = async () => {
//    //    try {
//    //        // Call the backend endpoint
//    //        const response = await apiFetch('/api/Rms/meters', { method: 'POST' });
//    //        const data = await response.json();

//    //        if (data.success) {
//    //            console.log('Meters list:', data.data);
//    //        } else {
//    //            console.error('Error fetching meters:', data.message);
//    //        }
//    //    } catch (e) {
//    //        Sentry.captureException(e);
//    //        if (e.message && e.message.includes('Session expired')) {
//    //            setSessionExpired(true);
//    //            logout();
//    //            return;
//    //        }
//    //        console.error('Error fetching meters data:', e);
//    //    }
//    //};

//    const fetchMeteoControlSystems = async () => {

//        try {
//            // Call your API endpoint using fetch without any token
//            const response = await fetch('/api/MeteoControl/systems', {
//                method: 'GET',
//                headers: {
//                    'Content-Type': 'application/json'
//                }
//            });

//            const data = await response.json();

//            // Check if the request was successful based on your Response wrapper
//            if (data.success) {
//                console.log('Systems fetched successfully:', data.data.data);
//            } else {

//                console.error('Error fetching systems:', data.message);
//            }
//        } catch (err) {
//            Sentry.captureException(err);
//            console.error('Exception when fetching systems:', err);
//        }
//    };

//    useEffect(() => {
//        AutenticateRMS();
//        //fetchMetersData();
//        fetchMeteoControlSystems();
//    }, []);

//    //useEffect(() => {
//    //    if (isRmsAuthenticated) {

//    //    }
//    //}, [isRmsAuthenticated]);

//  return (
//      <table>
//          <thead>
//              <tr>
//                  <th>Operations Sustainability Statistics</th>
//                  <th>
//                      Month<br />
//                      {monthName} {year}
//                  </th>
//                  <th>
//                      Year to Date<br />
//                      {monthName} {year}
//                  </th>
//                  <th>{`Year Ended December ${prevYear}`}</th>
//              </tr>
//          </thead>
//          <tbody>
//              <tr>
//                  <td>Solar power generated (kWp)</td>
//                  {/*<td>{loading ? 'Loading...' : ''}</td>*/}
//                  <td>17003</td>
//                  <td>{loading ? 'Loading...' : ''}</td>
//                  <td>{loading ? 'Loading...' : ''}</td>
//              </tr>
//              <tr>
//                  <td>Solar savings (R)</td>
//                  {/*<td>{loading ? 'Loading...' : ''}</td>*/}
//                  {/*<td>{loading ? 'Loading...' : ''}</td>*/}
//                  {/*<td>{loading ? 'Loading...' : ''}</td>*/}
//                  <td>R 2 827 634</td>
//                  <td>R 13 729 307</td>
//                  <td>{loading ? 'Loading...' : ''}</td>
//              </tr>
//              <tr>
//                  <td>Water extracted boreholes (treated/kilolitres)</td>
//                  <td>{loading ? 'Loading...' : ''}</td>
//                  <td>{loading ? 'Loading...' : ''}</td>
//                  <td>{loading ? 'Loading...' : ''}</td>
//              </tr>
//              <tr>
//                  <td>Water extracted savings (R)</td>
//                  <td>{loading ? 'Loading...' : ''}</td>
//                  <td>{loading ? 'Loading...' : ''}</td>
//                  <td>{loading ? 'Loading...' : ''}</td>

//              </tr>
//          </tbody>
//      </table>
//  );
//};

//export default OpsSustainabilityData;

import { useState, useEffect } from 'react';
import { useAuth } from '@/context/AuthContext';
import * as Sentry from '@sentry/react';

const monthNames = [
    '', 'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'
];

function getMonthYear(period) {
    if (!period) return { monthName: '', year: '', prevYear: '' };
    const periodStr = period.toString().padStart(6, '0');
    if (periodStr.length !== 6) return { monthName: '', year: '', prevYear: '' };
    const year = periodStr.substring(0, 4);
    const prevYear = (parseInt(year, 10) - 1).toString();
    const month = periodStr.substring(4, 6);
    const monthIndex = parseInt(month, 10);
    return {
        monthName: monthNames[monthIndex],
        year,
        prevYear
    };
}

function processSustainabilityStats(allStats, period) {
    if (!allStats || allStats.length === 0 || !period) return null;

    const periodStr = period.toString().padStart(6, '0');
    const year = parseInt(periodStr.substring(0, 4), 10);
    const month = parseInt(periodStr.substring(4, 6), 10);
    const prevYear = year - 1;
    const prevYearLastPeriod = prevYear * 100 + 12;
    const periodInt = year * 100 + month;

    // Find current period row
    const currentRow = allStats.find(row => row.period === periodInt);

    // Find all rows for YTD (Jan to current month of current year)
    const ytdRows = allStats.filter(row => {
        const rowYear = Math.floor(row.period / 100);
        const rowMonth = row.period % 100;
        return rowYear === year && rowMonth >= 1 && rowMonth <= month;
    });

    // Find previous year last period row
    const prevYearRow = allStats.find(row => row.period === prevYearLastPeriod);

    // Helper to average a field over an array of rows
    const avg = (rows, field) => {
        const valid = rows.map(r => r[field]).filter(v => typeof v === 'number' && !isNaN(v));
        if (!valid.length) return 0;
        return (valid.reduce((a, b) => a + b, 0) / valid.length).toFixed(2);
    };

    // Helper to get value or 0
    const valOrZero = (row, field) => {
        if (!row || row[field] == null || row[field] === 0) return '0.00';
        return Number(row[field]).toFixed(2);
    };

    return {
        solarPowerGenerated: [
            valOrZero(currentRow, 'solarPowerGenerated'),
            avg(ytdRows, 'solarPowerGenerated'),
            valOrZero(prevYearRow, 'solarPowerGenerated')
        ],
        solarSavings: [
            valOrZero(currentRow, 'solarSavings'),
            avg(ytdRows, 'solarSavings'),
            valOrZero(prevYearRow, 'solarSavings')
        ],
        waterExtractedBoreholes: [
            valOrZero(currentRow, 'waterExtractedBoreholes'),
            avg(ytdRows, 'waterExtractedBoreholes'),
            valOrZero(prevYearRow, 'waterExtractedBoreholes')
        ],
        waterSavings: [
            valOrZero(currentRow, 'waterSavings'),
            avg(ytdRows, 'waterSavings'),
            valOrZero(prevYearRow, 'waterSavings')
        ]
    };
}

const OpsSustainabilityData = ({ period }) => {
    const { apiFetch } = useAuth();
    const [allStats, setAllStats] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchStats = async () => {
            setLoading(true);
            try {
                const response = await apiFetch('/api/Sustainability/TempSustainabilityStats/all');
                const data = await response.json();
                if (data.success && Array.isArray(data.data)) {
                    setAllStats(data.data);
                } else {
                    setAllStats([]);
                }
            } catch (catchError) {
                Sentry.captureException(catchError);
                setAllStats([]);
            } finally {
                setLoading(false);
            }
        };
        fetchStats();
    }, [period, apiFetch]);

    const { monthName, year, prevYear } = getMonthYear(period);
    const stats = processSustainabilityStats(allStats, period);

    if (loading || !stats) {
        return <div>Loading sustainability statistics...</div>;
    }

    return (
        <table>
            <thead>
                <tr>
                    <th>Operations Sustainability Statistics</th>
                    <th>
                        Month<br />
                        {monthName} {year}
                    </th>
                    <th>
                        Year to Date<br />
                        {monthName} {year}
                    </th>
                    <th>
                        Year Ended<br />
                        {`December ${prevYear}`}
                    </th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td>Solar power generated (kWp)</td>
                    <td>{stats.solarPowerGenerated[0]}</td>
                    <td>{stats.solarPowerGenerated[1]}</td>
                    <td>{stats.solarPowerGenerated[2]}</td>
                </tr>
                <tr>
                    <td>Solar savings (R)</td>
                    <td>R {stats.solarSavings[0]}</td>
                    <td>R {stats.solarSavings[1]}</td>
                    <td>R {stats.solarSavings[2]}</td>
                </tr>
                <tr>
                    <td>Water extracted boreholes (treated/kilolitres)</td>
                    <td>{stats.waterExtractedBoreholes[0]}</td>
                    <td>{stats.waterExtractedBoreholes[1]}</td>
                    <td>{stats.waterExtractedBoreholes[2]}</td>
                </tr>
                <tr>
                    <td>Water extracted savings (R)</td>
                    <td>R {stats.waterSavings[0]}</td>
                    <td>R {stats.waterSavings[1]}</td>
                    <td>R {stats.waterSavings[2]}</td>
                </tr>
            </tbody>
        </table>
    );
};

export default OpsSustainabilityData;